
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import { APICreatePreferences } from '@/api/kpi';
import CompareStoresFilter from './CompareStoresFilter.vue';

export default {
  components: ['CompareStoresFilter'],
  props: {
    selectedOptions: {
      type: Array,
      required: false,
      default: () => []
    } // elevated
  }, // props

  data() {
    return {
      search: '',
      markedOptions: [],
      listState: null,
      flag: false,
      sortFirst: false
    };
  },
  computed: {
    ...mapState('store', ['stores']),
    ...mapState('filter', ['filter']),
    ...mapState('user', ['profile']),
    ...mapGetters('filter', [
      'getStartingPeriod',
      'getEndingPeriod',
      'getEndingCompared',
      'getStartingCompared'
    ]),
    /**
     * List of options. It gets updated if the user operates an search.
     */
    searchResult() {
      if (this.search) {
        return this.options?.filter(
          option =>
            option.label.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
        );
      } else {
        return this.options;
      }
    }, // searchResult
    options() {
      if (this.stores) {
        let stores = this.stores.stores ?? [];
        // sort store by storeCode
        // stores.sort((a, b) => {
        //   return a.storeCode - b.storeCode;
        // });
        const {
          tenant: { _id }
        } = this.profile;
        if (this.flag === false) {
          if (!(_id === 'bdjeWmpnCvrFQujim' && !this.sortFirst)) {
            stores.sort((a, b) => a.storeCode - b.storeCode);
          }
          // this.flag= false;
        } else {
          stores.sort((a, b) => {
            return b.storeCode - a.storeCode;
          });
          // this.flag= false;
        }
        // else
        // {
        //   debugger;
        //   stores.sort((a, b) => {
        //     return b.storeCode - a.storeCode;
        //   });
        //   this.flag= true;
        // }

        return stores?.map(store => {
          return {
            label: store.storeCode + ' -  ' + store.name,
            value: store.storeCode,
            openDate: store.openDate
          };
        });
        // + '  ' + (store.status === 1? " (Closed)" : "")
        // filter store as per authorization
        // .filter(v => this.profile.stores.split(',').includes(v.value))
      } // if (this.stores.regions)

      return [];
    }, // options
    loading() {
      if (this.options?.length) {
        return false;
      } else {
        return true;
      }
    }
  }, // computed
  watch: {
    'filter.storeCodes'(newData) {
      this.setStoreCodesFromHierarchy();
      this.refreshPage();
    },
    filter: {
      handler() {
        this.refreshPage();
      },
      deep: true
    },
    searchResult() {
    this.updateListState();
  },
  },
  async created() {
    // Set default selection
    await this.fetchStores();
    // this.markedOptions =
    //   this.selectedOptions.filter(v => this.profile?.stores?.includes(v)) || [];
    // this.markedOptions = this.selectedOptions;
    var allStoresList = this.stores?.stores?.map(s => s.storeCode);
    // this.selectedOptions =  allStoresList.filter(v => this.filter.storeCodes.includes(v)) || [];
    this.markedOptions =
      allStoresList?.filter(v => this.filter?.storeCodes?.includes(v)) || []; //this.selectedOptions;
     
    this.getCitiesForWeather();
  }, // created

  methods: {
    ...mapActions('store', ['fetchStores']),
    ...mapMutations('filter', ['setStoreCodes']),
    getCitiesForWeather() {
      var listOfMarkedCities =
        this.stores?.stores.filter(v =>
          this.filter?.storeCodes?.includes(v.storeCode)
        ) || [];
      this.$emit('selectedCities', listOfMarkedCities);
    },
    refreshPage() {
      const bol = JSON.parse(localStorage.getItem('checkOption'));
      this.handleChange(bol);
    },

  updateListState() {
    const visibleValues = this.searchResult.map(option => option.value);
    const selectedInView = visibleValues.filter(val => this.markedOptions.includes(val));

    if (selectedInView.length === visibleValues.length && visibleValues.length > 0) {
      this.listState = true;
    } else if (selectedInView.length === 0) {
      this.listState = false;
    } else {
      this.listState = null;
    }
  },

    /**
     * Mark all options as selected|
     */
    handleChange(value) {
      if (value) {
        const start = new Date(this.getStartingPeriod);
        const startC = new Date(this.getStartingCompared);
        //
        const filteredStores = this.options?.filter(store => {
          // Normalize to yyyy-mm-dd
          const normalizedDateStr = store.openDate?.replace(/\//g, '-');
          const openDate = new Date(normalizedDateStr);
          return openDate > start || openDate > startC;
        });
        const mapArr = filteredStores.map(item => item.value);
        this.markedOptions = this.markedOptions.filter(
          item => !mapArr.includes(item)
        );
       
      } else {
        const ar = localStorage.getItem('storeCodes')?.split(',');
        this.markedOptions = ar;
      }
    },
    setStoreCodesFromHierarchy() {
      var allStoresList = this.stores?.stores?.map(s => s.storeCode);
      this.markedOptions =
        allStoresList?.filter(v => this.filter?.storeCodes?.includes(v)) || [];
      
      // this.markedOptions = this.filter.storeCodes;
    },
    // markAllOptions() {
    //   this.markedOptions = this.options?.map(option => option.value);
    // },
    markAllOptions() {
        const currentVisible = this.searchResult?.map(option => option.value) || [];
        const alreadySelected = this.markedOptions || [];
        const merged = Array.from(new Set([...alreadySelected, ...currentVisible]));
        this.markedOptions = merged;
      },

    /**
     * 
     * Fired when user click on 'All' checkbox
     */
    // listStateInput(newValue) {
    //   if (newValue) {
    //     this.markAllOptions();
    //   } else {
    //     this.markedOptions = [];
    //   }
    // },
    listStateInput(newValue) {
      const currentList = this.search?.length > 0 ? this.searchResult : this.options;
      const visibleValues = currentList.map(option => option.value);
      
      if (newValue) {
        const combined = Array.from(new Set([...this.markedOptions, ...visibleValues]));
        this.markedOptions = combined;
      } else {
        this.markedOptions = this.markedOptions.filter(val => !visibleValues.includes(val));
      }
    },



    /**
     * Fired when user click on any checkbox apart from 'All'
     */
    markedOptionsInput(newValue) {
      this.updateListState();
    }, // markedOptionsInput
    /**
     * Update selected options before closing the filter
     */
    submit() {
      var urlPage = '/';
      // var urlPage = window.location.pathname;
      // Check if minimum of 1 store is selected

      if (this.markedOptions.length === 0) {
        return false;
      }
      // Save preferences in localStorage
      // APICreatePreferences(urlPage, this.markedOptions.toString());
      const overStores = this.stores?.stores?.map(s => s.storeCode);
      this.markedOptions = this.markedOptions.filter(el => {
        return overStores.includes(el);
      })
      APICreatePreferences(urlPage, this.markedOptions);
      // Updates the parent
      this.$emit('update:selectedOptions', this.markedOptions);
      this.setStoreCodes({ storeCodes: this.markedOptions });
      localStorage.removeItem('weather');
      localStorage.removeItem('weatherCompare');
      this.getCitiesForWeather();
      // Hide the filter
      this.$refs.filterStore.hide();
    }, // submit
    /**
     * Closes the filter without saving selected options
     */
    hide() {
      this.markedOptions = this.selectedOptions;
      this.$refs.filterStore.hide();
    }, // hide
    sortOptions() {
      if (this.stores) {
        let stores = this.stores.stores ?? [];
        if (this.flag === false) {
          this.sortFirst = true;
          this.flag = true;
        } else {
          this.flag = false;
        }
      }
    }
  }
};
